
import { Component, MouseEventHandler, useEffect, useRef, useState } from "react";
import { BarContainer, BarLabel, BlueButton, ButtonContainer, DocumentButton, FormWhiteContainer, LabelContainer, ShortBlueButton } from "../../assets/style";
import { Box, Grid, IconButton } from "@mui/material";
import FormDatePicker from "../FormDatePicker";
import FormInput from "../FormInput";
import { deleteIcon } from "../../assets/imgs";
import dayjs from "dayjs";
import axios from "axios";
import { CertificateModel, SafetyRelatedCert, trainingDetail } from "../../models/WorkerModel";
import { v4 as uuidv4 } from 'uuid';
import { useLazyGetWorkerFileQuery } from "../../features/worker/workerSlice";

export default function TrainingDetailContainer(props: {
    trainingDetail?: CertificateModel,
    onAddTrainingDetail?: (newtrainingDetail: CertificateModel) => void,
    onEditTrainingDetail?: (trainingDetail: CertificateModel) => void,
    onDelete?: () => void;
    onCancel?: () => void;
}) {
    const { trainingDetail, onAddTrainingDetail, onEditTrainingDetail, onDelete, onCancel } = props;
    const [certificationName, setCertificationName] = useState(trainingDetail?.certificationName || "");
    const [trainingDate, setTrainingDate] = useState(dayjs(trainingDetail?.trainingDate, "DD/MM/YYYY") || dayjs(null));
    const attachmentInputRef = useRef<HTMLInputElement>(null);
    const [attachment, setAttachment] = useState<File | null | undefined>(trainingDetail?.certificationFile);
    const [isMounted, setIsMounted] = useState(false)
    const [hasUnsavedChanges, setHasUnsaveChanges] = useState(false)

    // save the values of training detail
    useEffect(() => {
        if (!trainingDetail) {
            return
        }

        if (!isMounted) {
            setIsMounted(true)
        } else {
            setHasUnsaveChanges(true)
        }
    }, [certificationName, trainingDate, attachment])

    const handleAttachmentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            setAttachment(selectedFile)
        }
    };

    const handleAttachmentButtonClick: MouseEventHandler<HTMLButtonElement> = () => {
        if (attachmentInputRef.current) {
            attachmentInputRef.current.click();
        }
    };

    const handleApply = () => {
        const newtrainingDetail: CertificateModel = {
            trainingDate: trainingDate.format('DD/MM/YYYY'), // Assign the formatted date string here
            certificationName: certificationName,
            certificationFile: attachment as File,
        };
        onAddTrainingDetail!(newtrainingDetail);
    };

    const handleEdit = () => {
        let updatedTrainingDetail: CertificateModel = {
            trainingDate: trainingDate.format('DD/MM/YYYY'),
            certificationName: certificationName,
            certificationFile: attachment as File
        }
        onEditTrainingDetail!(updatedTrainingDetail);
    };

    const getLink = function (file: File | null | undefined) {
        if (file) {
            return <a
                onClick={() => { displayImageInNewTab(file, file.name) }}
                href={"javascript:;"}
                style={{ marginLeft: '10px' }}
                target="_blank"
                rel="noopener noreferrer"
            >
                {file.name}
            </a>
        } else {
            return ""
        }
    }

    const displayImageInNewTab = function (blob: Blob, filename: string) {
        const imageUrl = URL.createObjectURL(blob);
        const newTab = window.open(imageUrl);
    }

    return (
        <FormWhiteContainer>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <FormDatePicker title={"Training Date"} value={trainingDate} setMethod={setTrainingDate} />
                {trainingDetail && <IconButton onClick={() => onDelete!()}>
                    <img src={deleteIcon} />
                </IconButton>}
                {!trainingDetail && <IconButton onClick={onCancel}>
                    <img src={deleteIcon} />
                </IconButton>}
            </Box>
            <FormInput title={"Training Certificate"} value={certificationName} setMethod={setCertificationName} />
            <ButtonContainer >
                <LabelContainer style={{ marginLeft: "28px" }}>
                    {"Attachments: "}
                </LabelContainer>
                <input type="file" ref={attachmentInputRef} accept="*" onChange={handleAttachmentChange} style={{ display: 'none' }} />
                <DocumentButton style={{ marginLeft: "18px" }} onClick={handleAttachmentButtonClick}>Select File</DocumentButton>
                {attachment && getLink(attachment)}
                {attachment &&
                    <IconButton onClick={() => setAttachment(null)}>
                        <img src={deleteIcon} />
                    </IconButton>
                }
            </ButtonContainer>
            {!trainingDetail && <ShortBlueButton
                onClick={handleApply}>
                Add
            </ShortBlueButton>}
            {(trainingDetail && hasUnsavedChanges) && <ShortBlueButton
                onClick={handleEdit}>
                Edit
            </ShortBlueButton>}

        </FormWhiteContainer >
    );
}
